export const FooterLink = {
  PrivacyPolicy: 'Privacy Policy',
  TermsPolicy: 'Terms of Use',
  ContactSupport: 'Contact Support',
};

export const FooterLinkProp = {
  Title: 'title',
  Url: 'url',
  IsExternal: 'isExternal',
};
